import script from "./Article.vue?vue&type=script&setup=true&lang=js"
export * from "./Article.vue?vue&type=script&setup=true&lang=js"

import "./Article.vue?vue&type=style&index=0&id=bca9d864&scoped=true&lang=css"

import exportComponent from "D:\\My Project\\NewBlog\\WEB\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bca9d864"]])

export default __exports__